import { useContext } from 'react';
import { useNavigate, useMatch } from 'react-router-dom';
import Icon from '../common/Icon/Icon';
import { IconKeys } from '../common/Icon/IconKeys';
import SearchInput from './SearchInput.tsx/SearchInput';
import S from './DynamicIslandStyles';
import WrapperContext from '../layout/PageWrapper/context';

const SEARCH_PATH = '/search';
function DynamicIsland(): JSX.Element {
  const navigate = useNavigate();
  const { setSearchInput } = useContext(WrapperContext);
  const isSearch = !!useMatch(SEARCH_PATH);

  const handleSearchClick = (input: string): void => {
    setSearchInput(input);
  };

  return (
    <S.Wrapper>
      {!isSearch ? (
        <>
          {/* <div className="events-container">
            <div className="alerts-container">
              <Icon iconKey={IconKeys.SPARK_ALERT} />
              <p className="count">4</p>
              <p className="label">alerts</p>
            </div>
            <div className="todos-container">
              <p className="count">4</p>
              <p className="label">to do's</p>
            </div>
            <div className="tips-container">
              <p className="count">6</p>
              <p className="label">safety tips</p>
            </div>
          </div> */}
          <div /> {/* Temporary div */}
          <button
            type="button"
            className="search-container"
            onClick={() => navigate('/search')}
          >
            <Icon iconKey={IconKeys.SEARCH} />
          </button>
        </>
      ) : (<SearchInput onSearchClick={handleSearchClick} />)}
    </S.Wrapper>
  );
}

export default DynamicIsland;
